import { ComponentPortal, PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { EventEmitter, Component, Input, Output, InjectionToken, Inject, Injector, Injectable, HostBinding, ElementRef, HostListener, NgModule } from '@angular/core';
import { IconModule } from '@onep/ng-uikit-lib/icon';
import { OverlayService, OverlayModule } from '@onep/ng-uikit-lib/overlay';
import { HeaderModule } from '@onep/ng-uikit-lib/ui/header';
import { ResponsiveService, GridModule } from '@onep/ng-uikit-lib/grid';
import { trigger, transition, style, group, animate, state } from '@angular/animations';
import { BehaviorSubject, Subject } from 'rxjs';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/cdk/portal';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@onep/ng-uikit-lib/icon';
import * as ɵngcc4 from '@onep/ng-uikit-lib/grid';
import * as ɵngcc5 from '@onep/ng-uikit-lib/overlay';
import * as ɵngcc6 from '@onep/ng-uikit-lib/ui/header';

function BottomModalComponent_ng_template_1_Template(rf, ctx) { }
const _c0 = function (a0) { return { "onep-header-divider": a0 }; };
const _c1 = ["*"];
function MaxiModalComponent_ng_template_1_Template(rf, ctx) { }
function MaxiModalComponent_ng_container_2_p_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "p", 5);
    ɵngcc0.ɵɵlistener("click", function MaxiModalComponent_ng_container_2_p_1_Template_p_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r4.closeModal.emit()); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r2.closeText);
} }
function MaxiModalComponent_ng_container_2__svg_svg_2_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", 6);
    ɵngcc0.ɵɵlistener("click", function MaxiModalComponent_ng_container_2__svg_svg_2_Template__svg_svg_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r6.closeModal.emit()); });
    ɵngcc0.ɵɵelementEnd();
} }
function MaxiModalComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, MaxiModalComponent_ng_container_2_p_1_Template, 2, 1, "p", 3);
    ɵngcc0.ɵɵtemplate(2, MaxiModalComponent_ng_container_2__svg_svg_2_Template, 1, 0, "svg", 4);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.closeText);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r1.closeText);
} }
function PopInModalComponent_ng_template_1_Template(rf, ctx) { }
function SideSheetComponent_ng_template_2_Template(rf, ctx) { }
function SideSheetV2Component_div_5_ng_template_1_Template(rf, ctx) { }
function SideSheetV2Component_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵnamespaceHTML();
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵtemplate(1, SideSheetV2Component_div_5_ng_template_1_Template, 0, 0, "ng-template", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("cdkPortalOutlet", ctx_r0.content);
} }
function SideSheetV2Component_6_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
} }
function SideSheetV2Component_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵtemplate(0, SideSheetV2Component_6_ng_template_0_Template, 0, 0, "ng-template", 5);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("cdkPortalOutlet", ctx_r1.content);
} }
class BottomModalComponent {
    constructor() {
        /**
         * Emits when the modal is closed
         */
        this.closeModal = new EventEmitter();
    }
    ngOnInit() { }
}
BottomModalComponent.ɵfac = function BottomModalComponent_Factory(t) { return new (t || BottomModalComponent)(); };
BottomModalComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BottomModalComponent, selectors: [["onep-bottom-modal"]], inputs: { content: "content" }, outputs: { closeModal: "closeModal" }, decls: 2, vars: 1, consts: [[1, "onep-bottom-modal-container"], [3, "cdkPortalOutlet"]], template: function BottomModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, BottomModalComponent_ng_template_1_Template, 0, 0, "ng-template", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("cdkPortalOutlet", ctx.content);
    } }, dependencies: [ɵngcc1.CdkPortalOutlet] });
BottomModalComponent.ctorParameters = () => [];
BottomModalComponent.propDecorators = {
    content: [{ type: Input }],
    closeModal: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BottomModalComponent, [{
        type: Component,
        args: [{ selector: 'onep-bottom-modal', template: "<div class=\"onep-bottom-modal-container\">\n  <ng-template [cdkPortalOutlet]=\"content\"></ng-template>\n</div>\n" }]
    }], function () { return []; }, { closeModal: [{
            type: Output
        }], content: [{
            type: Input
        }] }); })();

const ONEP_MODAL_DATA = new InjectionToken('ONEP_MODAL_DATA');

/**
 * Component that displays and controls a bottom modal
 */
class ControlBottomModalComponent {
    constructor(data) {
        this.data = data;
        this.modalState = 'in';
    }
    ngOnInit() {
        this.data.wantsToCloseSubject.subscribe((wantedResult) => {
            this.onClose(wantedResult);
        });
    }
    onAnimationEvent(event) {
        if (event.toState === 'closing' && event.phaseName === 'done') {
            this.destroy();
        }
    }
    onClose(wantedResult) {
        this.wantedResult = wantedResult;
        this.modalState = 'closing';
    }
    destroy() {
        this.data.close.next(this.wantedResult);
        this.data.close.complete();
    }
}
ControlBottomModalComponent.ɵfac = function ControlBottomModalComponent_Factory(t) { return new (t || ControlBottomModalComponent)(ɵngcc0.ɵɵdirectiveInject(ONEP_MODAL_DATA)); };
ControlBottomModalComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ControlBottomModalComponent, selectors: [["onep-control-bottom-modal"]], decls: 1, vars: 2, consts: [[3, "content", "closeModal"]], template: function ControlBottomModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "onep-bottom-modal", 0);
        ɵngcc0.ɵɵlistener("closeModal", function ControlBottomModalComponent_Template_onep_bottom_modal_closeModal_0_listener() { return ctx.onClose(undefined); })("@fadeInAnimation.start", function ControlBottomModalComponent_Template_onep_bottom_modal_animation_fadeInAnimation_start_0_listener($event) { return ctx.onAnimationEvent($event); })("@fadeInAnimation.done", function ControlBottomModalComponent_Template_onep_bottom_modal_animation_fadeInAnimation_done_0_listener($event) { return ctx.onAnimationEvent($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("content", ctx.data.content)("@fadeInAnimation", ctx.modalState);
    } }, dependencies: [BottomModalComponent], encapsulation: 2, data: { animation: [
            trigger('fadeInAnimation', [
                transition('void => in', [
                    style({ opacity: 0, transform: 'translateY(100%)' }),
                    group([
                        animate('300ms', style({ opacity: 1 })),
                        animate('300ms ease-out', style({ transform: 'translateY(0)' }))
                    ])
                ]),
                transition('in => closing', [
                    style({ opacity: 1, transform: 'translateY(0)' }),
                    group([
                        animate('300ms', style({ opacity: 0 })),
                        animate('300ms ease-out', style({ transform: 'translateY(100%)' }))
                    ])
                ])
            ])
        ] } });
ControlBottomModalComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [ONEP_MODAL_DATA,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ControlBottomModalComponent, [{
        type: Component,
        args: [{
                selector: 'onep-control-bottom-modal',
                template: "<onep-bottom-modal\n  (closeModal)=\"onClose(undefined)\"\n  [content]=\"data.content\"\n  [@fadeInAnimation]=\"modalState\"\n  (@fadeInAnimation.start)=\"onAnimationEvent($event)\"\n  (@fadeInAnimation.done)=\"onAnimationEvent($event)\">\n</onep-bottom-modal>\n",
                animations: [
                    trigger('fadeInAnimation', [
                        transition('void => in', [
                            style({ opacity: 0, transform: 'translateY(100%)' }),
                            group([
                                animate('300ms', style({ opacity: 1 })),
                                animate('300ms ease-out', style({ transform: 'translateY(0)' }))
                            ])
                        ]),
                        transition('in => closing', [
                            style({ opacity: 1, transform: 'translateY(0)' }),
                            group([
                                animate('300ms', style({ opacity: 0 })),
                                animate('300ms ease-out', style({ transform: 'translateY(100%)' }))
                            ])
                        ])
                    ])
                ]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [ONEP_MODAL_DATA]
            }] }]; }, null); })();

/**
 * Component that displays and controls a pop in modal
 */
class ControlMaxiModalComponent {
    constructor(data) {
        this.data = data;
        this.modalState = 'in';
    }
    ngOnInit() {
        this.data.wantsToCloseSubject.subscribe((wantedResult) => {
            this.onClose(wantedResult);
        });
    }
    onAnimationEvent(event) {
        if (event.toState === 'closing' && event.phaseName === 'done') {
            this.destroy();
        }
    }
    onClose(wantedResult) {
        this.wantedResult = wantedResult;
        this.modalState = 'closing';
    }
    destroy() {
        this.data.close.next(this.wantedResult);
        this.data.close.complete();
    }
}
ControlMaxiModalComponent.ɵfac = function ControlMaxiModalComponent_Factory(t) { return new (t || ControlMaxiModalComponent)(ɵngcc0.ɵɵdirectiveInject(ONEP_MODAL_DATA)); };
ControlMaxiModalComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ControlMaxiModalComponent, selectors: [["onep-control-maxi-modal"]], decls: 1, vars: 4, consts: [[3, "content", "closeText", "displayClose", "closeModal"]], template: function ControlMaxiModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "onep-maxi-modal", 0);
        ɵngcc0.ɵɵlistener("closeModal", function ControlMaxiModalComponent_Template_onep_maxi_modal_closeModal_0_listener() { return ctx.onClose(undefined); })("@fadeInAnimation.start", function ControlMaxiModalComponent_Template_onep_maxi_modal_animation_fadeInAnimation_start_0_listener($event) { return ctx.onAnimationEvent($event); })("@fadeInAnimation.done", function ControlMaxiModalComponent_Template_onep_maxi_modal_animation_fadeInAnimation_done_0_listener($event) { return ctx.onAnimationEvent($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("content", ctx.data.content)("closeText", ctx.data.closeText)("displayClose", ctx.data.displayClose)("@fadeInAnimation", ctx.modalState);
    } }, dependencies: function () { return [MaxiModalComponent]; }, encapsulation: 2, data: { animation: [
            trigger('fadeInAnimation', [
                transition('void => in', [
                    style({ opacity: 1, transform: 'translateY(100%)' }),
                    group([
                        animate('300ms', style({ opacity: 1 })),
                        animate('300ms ease-out', style({ transform: 'translateY(0)' }))
                    ])
                ]),
                transition('in => closing', [
                    style({ opacity: 1, transform: 'translateY(0)' }),
                    group([
                        animate('300ms', style({ opacity: 1 })),
                        animate('300ms ease-out', style({ transform: 'translateY(100%)' }))
                    ])
                ])
            ])
        ] } });
ControlMaxiModalComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [ONEP_MODAL_DATA,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ControlMaxiModalComponent, [{
        type: Component,
        args: [{
                selector: 'onep-control-maxi-modal',
                template: "<onep-maxi-modal\n  (closeModal)=\"onClose(undefined)\"\n  [content]=\"data.content\"\n  [closeText]=\"data.closeText\"\n  [displayClose]=\"data.displayClose\"\n  [@fadeInAnimation]=\"modalState\"\n  (@fadeInAnimation.start)=\"onAnimationEvent($event)\"\n  (@fadeInAnimation.done)=\"onAnimationEvent($event)\">\n</onep-maxi-modal>\n",
                animations: [
                    trigger('fadeInAnimation', [
                        transition('void => in', [
                            style({ opacity: 1, transform: 'translateY(100%)' }),
                            group([
                                animate('300ms', style({ opacity: 1 })),
                                animate('300ms ease-out', style({ transform: 'translateY(0)' }))
                            ])
                        ]),
                        transition('in => closing', [
                            style({ opacity: 1, transform: 'translateY(0)' }),
                            group([
                                animate('300ms', style({ opacity: 1 })),
                                animate('300ms ease-out', style({ transform: 'translateY(100%)' }))
                            ])
                        ])
                    ])
                ]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [ONEP_MODAL_DATA]
            }] }]; }, null); })();

/**
 * @deprecated
 */
class HeaderMaxiModalComponent {
    constructor() {
        /**
         * Emits something when the modal is closed
         */
        this.closeModal = new EventEmitter();
        this.displayHeaderLine = false;
    }
    ngOnInit() { }
}
HeaderMaxiModalComponent.ɵfac = function HeaderMaxiModalComponent_Factory(t) { return new (t || HeaderMaxiModalComponent)(); };
HeaderMaxiModalComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HeaderMaxiModalComponent, selectors: [["onep-header-maxi-modal"]], inputs: { displayHeaderLine: "displayHeaderLine" }, outputs: { closeModal: "closeModal" }, ngContentSelectors: _c1, decls: 4, vars: 3, consts: [[1, "onep-header-maxi-modal-container"], ["onepIcon", "close_error", 1, "onep-maxi-modal-close", 3, "click"], [3, "ngClass"]], template: function HeaderMaxiModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(2, "svg", 1);
        ɵngcc0.ɵɵlistener("click", function HeaderMaxiModalComponent_Template__svg_svg_click_2_listener() { return ctx.closeModal.emit(); });
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelement(3, "div", 2);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(1, _c0, ctx.displayHeaderLine));
    } }, dependencies: [ɵngcc2.NgClass, ɵngcc3.IconComponent] });
HeaderMaxiModalComponent.ctorParameters = () => [];
HeaderMaxiModalComponent.propDecorators = {
    closeModal: [{ type: Output }],
    displayHeaderLine: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HeaderMaxiModalComponent, [{
        type: Component,
        args: [{ selector: 'onep-header-maxi-modal', template: "<div class=\"onep-header-maxi-modal-container\">\n  <ng-content></ng-content>\n  <svg class=\"onep-maxi-modal-close\" (click)=\"closeModal.emit()\" onepIcon=\"close_error\"></svg>\n</div>\n<div [ngClass]=\"{\n'onep-header-divider': displayHeaderLine\n}\">\n" }]
    }], function () { return []; }, { closeModal: [{
            type: Output
        }], displayHeaderLine: [{
            type: Input
        }] }); })();

/**
 * Component that wraps the maxi modal pattern
 */
class MaxiModalComponent {
    constructor(responsiveService) {
        this.responsiveService = responsiveService;
        this.subscriptions = [];
        /**
         * Close text
         */
        this.closeText = '';
        /**
         * If the component should display a close button (default true)
         */
        this.displayClose = true;
        /**
         * Emits something when the modal is closed
         */
        this.closeModal = new EventEmitter();
        this.isMobile = false;
    }
    ngOnInit() {
        this.subscriptions.push(this.responsiveService.isMobile$.subscribe((isMobile) => {
            this.isMobile = isMobile;
        }));
    }
    ngOnDestroy() {
        this.subscriptions.forEach((s) => s.unsubscribe());
    }
}
MaxiModalComponent.ɵfac = function MaxiModalComponent_Factory(t) { return new (t || MaxiModalComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.ResponsiveService)); };
MaxiModalComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MaxiModalComponent, selectors: [["onep-maxi-modal"]], inputs: { closeText: "closeText", displayClose: "displayClose", content: "content" }, outputs: { closeModal: "closeModal" }, decls: 3, vars: 2, consts: [[1, "onep-maxi-modal-container"], [3, "cdkPortalOutlet"], [4, "ngIf"], ["class", "onep-maxi-modal-close-text", 3, "click", 4, "ngIf"], ["class", "onep-maxi-modal-close", "onepIcon", "close_error", 3, "click", 4, "ngIf"], [1, "onep-maxi-modal-close-text", 3, "click"], ["onepIcon", "close_error", 1, "onep-maxi-modal-close", 3, "click"]], template: function MaxiModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, MaxiModalComponent_ng_template_1_Template, 0, 0, "ng-template", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(2, MaxiModalComponent_ng_container_2_Template, 3, 2, "ng-container", 2);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("cdkPortalOutlet", ctx.content);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.displayClose);
    } }, dependencies: [ɵngcc2.NgIf, ɵngcc3.IconComponent, ɵngcc1.CdkPortalOutlet], encapsulation: 2 });
MaxiModalComponent.ctorParameters = () => [
    { type: ResponsiveService }
];
MaxiModalComponent.propDecorators = {
    content: [{ type: Input }],
    closeText: [{ type: Input }],
    displayClose: [{ type: Input }],
    closeModal: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MaxiModalComponent, [{
        type: Component,
        args: [{
                selector: 'onep-maxi-modal',
                template: "<div class=\"onep-maxi-modal-container\">\n  <ng-template [cdkPortalOutlet]=\"content\"></ng-template>\n</div>\n<ng-container *ngIf=\"displayClose\">\n  <p *ngIf=\"closeText\" class=\"onep-maxi-modal-close-text\" (click)=\"closeModal.emit()\">{{closeText}}</p>\n  <svg *ngIf=\"!closeText\" class=\"onep-maxi-modal-close\" (click)=\"closeModal.emit()\" onepIcon=\"close_error\"></svg>\n</ng-container>\n"
            }]
    }], function () { return [{ type: ɵngcc4.ResponsiveService }]; }, { closeText: [{
            type: Input
        }], displayClose: [{
            type: Input
        }], closeModal: [{
            type: Output
        }], content: [{
            type: Input
        }] }); })();

/**
 * Component that displays and controls a pop in modal
 */
class ControlPopInModalComponent {
    constructor(data) {
        this.data = data;
        this.modalState = 'in';
    }
    ngOnInit() {
        this.data.wantsToCloseSubject.subscribe((wantedResult) => {
            this.onClose(wantedResult);
        });
    }
    onAnimationEvent(event) {
        if (event.toState === 'closing' && event.phaseName === 'done') {
            this.destroy();
        }
    }
    onClose(wantedResult) {
        this.wantedResult = wantedResult;
        this.modalState = 'closing';
    }
    destroy() {
        this.data.close.next(this.wantedResult);
        this.data.close.complete();
    }
}
ControlPopInModalComponent.ɵfac = function ControlPopInModalComponent_Factory(t) { return new (t || ControlPopInModalComponent)(ɵngcc0.ɵɵdirectiveInject(ONEP_MODAL_DATA)); };
ControlPopInModalComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ControlPopInModalComponent, selectors: [["onep-control-pop-in-modal"]], decls: 1, vars: 3, consts: [[3, "className", "content", "closeModal"]], template: function ControlPopInModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "onep-pop-in-modal", 0);
        ɵngcc0.ɵɵlistener("closeModal", function ControlPopInModalComponent_Template_onep_pop_in_modal_closeModal_0_listener() { return ctx.onClose(undefined); })("@fadeAndSlideAnimation.start", function ControlPopInModalComponent_Template_onep_pop_in_modal_animation_fadeAndSlideAnimation_start_0_listener($event) { return ctx.onAnimationEvent($event); })("@fadeAndSlideAnimation.done", function ControlPopInModalComponent_Template_onep_pop_in_modal_animation_fadeAndSlideAnimation_done_0_listener($event) { return ctx.onAnimationEvent($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("className", ctx.data.class)("content", ctx.data.content)("@fadeAndSlideAnimation", ctx.modalState);
    } }, dependencies: function () { return [PopInModalComponent]; }, encapsulation: 2, data: { animation: [
            trigger('fadeAndSlideAnimation', [
                transition('void => in', [
                    style({ opacity: 0, transform: 'translateY(56px)' }),
                    group([
                        animate('300ms', style({ opacity: 1 })),
                        animate('300ms ease-out', style({ transform: 'translateY(0)' }))
                    ])
                ]),
                transition('in => closing', [
                    style({ opacity: 1, transform: 'translateY(0)' }),
                    group([
                        animate('300ms', style({ opacity: 0 })),
                        animate('300ms ease-out', style({ transform: 'translateY(56px)' }))
                    ])
                ])
            ])
        ] } });
ControlPopInModalComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [ONEP_MODAL_DATA,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ControlPopInModalComponent, [{
        type: Component,
        args: [{
                selector: 'onep-control-pop-in-modal',
                template: "<onep-pop-in-modal\n  [className]=\"data.class\"\n  (closeModal)=\"onClose(undefined)\"\n  [content]=\"data.content\"\n  [@fadeAndSlideAnimation]=\"modalState\"\n  (@fadeAndSlideAnimation.start)=\"onAnimationEvent($event)\"\n  (@fadeAndSlideAnimation.done)=\"onAnimationEvent($event)\">\n</onep-pop-in-modal>\n",
                animations: [
                    trigger('fadeAndSlideAnimation', [
                        transition('void => in', [
                            style({ opacity: 0, transform: 'translateY(56px)' }),
                            group([
                                animate('300ms', style({ opacity: 1 })),
                                animate('300ms ease-out', style({ transform: 'translateY(0)' }))
                            ])
                        ]),
                        transition('in => closing', [
                            style({ opacity: 1, transform: 'translateY(0)' }),
                            group([
                                animate('300ms', style({ opacity: 0 })),
                                animate('300ms ease-out', style({ transform: 'translateY(56px)' }))
                            ])
                        ])
                    ])
                ]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [ONEP_MODAL_DATA]
            }] }]; }, null); })();

class ControlSideSheetV2Component {
    constructor(data) {
        this.data = data;
        this.modalState = 'in';
    }
    ngOnInit() {
        this.data.wantsToCloseSubject.subscribe((wantedResult) => {
            this.onClose(wantedResult);
        });
    }
    onAnimationEvent(event) {
        if (event.toState === 'closing' && event.phaseName === 'done') {
            this.destroy();
        }
    }
    onClose(wantedResult) {
        this.wantedResult = wantedResult;
        this.modalState = 'closing';
    }
    destroy() {
        this.data.close.next(this.wantedResult);
        this.data.close.complete();
    }
}
ControlSideSheetV2Component.ɵfac = function ControlSideSheetV2Component_Factory(t) { return new (t || ControlSideSheetV2Component)(ɵngcc0.ɵɵdirectiveInject(ONEP_MODAL_DATA)); };
ControlSideSheetV2Component.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ControlSideSheetV2Component, selectors: [["onep-control-side-sheet-v2"]], decls: 1, vars: 3, consts: [[3, "content", "fullHeight", "closeModal"]], template: function ControlSideSheetV2Component_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "onep-side-sheet-v2", 0);
        ɵngcc0.ɵɵlistener("closeModal", function ControlSideSheetV2Component_Template_onep_side_sheet_v2_closeModal_0_listener() { return ctx.onClose(undefined); })("@fadeAndSlideAnimation.start", function ControlSideSheetV2Component_Template_onep_side_sheet_v2_animation_fadeAndSlideAnimation_start_0_listener($event) { return ctx.onAnimationEvent($event); })("@fadeAndSlideAnimation.done", function ControlSideSheetV2Component_Template_onep_side_sheet_v2_animation_fadeAndSlideAnimation_done_0_listener($event) { return ctx.onAnimationEvent($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("content", ctx.data.content)("fullHeight", ctx.data.fullHeight)("@fadeAndSlideAnimation", ctx.modalState);
    } }, dependencies: function () { return [SideSheetV2Component]; }, encapsulation: 2, data: { animation: [
            trigger('fadeAndSlideAnimation', [
                state('in', style({ transform: 'translateX(0)', opacity: 1 })),
                state('closing', style({ transform: 'translateX(100%)', opacity: 0 })),
                transition('in => closing', animate(200)),
                transition(':enter', [
                    style({ transform: 'translateX(100%)', opacity: 0 }),
                    animate(200)
                ])
            ])
        ] } });
ControlSideSheetV2Component.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [ONEP_MODAL_DATA,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ControlSideSheetV2Component, [{
        type: Component,
        args: [{
                selector: 'onep-control-side-sheet-v2',
                template: "<onep-side-sheet-v2\n  (closeModal)=\"onClose(undefined)\"\n  [content]=\"data.content\"\n  [fullHeight]=\"data.fullHeight\"\n  [@fadeAndSlideAnimation]=\"modalState\"\n  (@fadeAndSlideAnimation.start)=\"onAnimationEvent($event)\"\n  (@fadeAndSlideAnimation.done)=\"onAnimationEvent($event)\">\n</onep-side-sheet-v2>\n",
                animations: [
                    trigger('fadeAndSlideAnimation', [
                        state('in', style({ transform: 'translateX(0)', opacity: 1 })),
                        state('closing', style({ transform: 'translateX(100%)', opacity: 0 })),
                        transition('in => closing', animate(200)),
                        transition(':enter', [
                            style({ transform: 'translateX(100%)', opacity: 0 }),
                            animate(200)
                        ])
                    ])
                ]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [ONEP_MODAL_DATA]
            }] }]; }, null); })();

/**
 * Component that displays and controls a side sheet
 */
class ControlSideSheetComponent {
    constructor(data) {
        this.data = data;
        this.modalState = 'in';
    }
    ngOnInit() {
        this.data.wantsToCloseSubject.subscribe((wantedResult) => {
            this.onClose(wantedResult);
        });
    }
    onAnimationEvent(event) {
        if (event.toState === 'closing' && event.phaseName === 'done') {
            this.destroy();
        }
    }
    onClose(wantedResult) {
        this.wantedResult = wantedResult;
        this.modalState = 'closing';
    }
    destroy() {
        this.data.close.next(this.wantedResult);
        this.data.close.complete();
    }
}
ControlSideSheetComponent.ɵfac = function ControlSideSheetComponent_Factory(t) { return new (t || ControlSideSheetComponent)(ɵngcc0.ɵɵdirectiveInject(ONEP_MODAL_DATA)); };
ControlSideSheetComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ControlSideSheetComponent, selectors: [["onep-control-side-sheet"]], decls: 1, vars: 2, consts: [[3, "content", "closeModal"]], template: function ControlSideSheetComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "onep-side-sheet", 0);
        ɵngcc0.ɵɵlistener("closeModal", function ControlSideSheetComponent_Template_onep_side_sheet_closeModal_0_listener() { return ctx.onClose(undefined); })("@fadeAndSlideAnimation.start", function ControlSideSheetComponent_Template_onep_side_sheet_animation_fadeAndSlideAnimation_start_0_listener($event) { return ctx.onAnimationEvent($event); })("@fadeAndSlideAnimation.done", function ControlSideSheetComponent_Template_onep_side_sheet_animation_fadeAndSlideAnimation_done_0_listener($event) { return ctx.onAnimationEvent($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("content", ctx.data.content)("@fadeAndSlideAnimation", ctx.modalState);
    } }, dependencies: function () { return [SideSheetComponent]; }, encapsulation: 2, data: { animation: [
            trigger('fadeAndSlideAnimation', [
                state('in', style({ transform: 'translateX(0)', opacity: 1 })),
                state('closing', style({ transform: 'translateX(100%)', opacity: 0 })),
                transition('in => closing', animate(200)),
                transition(':enter', [
                    style({ transform: 'translateX(100%)', opacity: 0 }),
                    animate(200)
                ])
            ])
        ] } });
ControlSideSheetComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [ONEP_MODAL_DATA,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ControlSideSheetComponent, [{
        type: Component,
        args: [{
                selector: 'onep-control-side-sheet',
                template: "<onep-side-sheet\n  (closeModal)=\"onClose(undefined)\"\n  [content]=\"data.content\"\n  [@fadeAndSlideAnimation]=\"modalState\"\n  (@fadeAndSlideAnimation.start)=\"onAnimationEvent($event)\"\n  (@fadeAndSlideAnimation.done)=\"onAnimationEvent($event)\">\n</onep-side-sheet>\n",
                animations: [
                    trigger('fadeAndSlideAnimation', [
                        state('in', style({ transform: 'translateX(0)', opacity: 1 })),
                        state('closing', style({ transform: 'translateX(100%)', opacity: 0 })),
                        transition('in => closing', animate(200)),
                        transition(':enter', [
                            style({ transform: 'translateX(100%)', opacity: 0 }),
                            animate(200)
                        ])
                    ])
                ]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [ONEP_MODAL_DATA]
            }] }]; }, null); })();

const ONEP_MODAL_INPUT = new InjectionToken('ONEP_MODAL_INPUT');

var ModalType;
(function (ModalType) {
    ModalType[ModalType["SideSheet"] = 0] = "SideSheet";
    ModalType[ModalType["SideSheetV2"] = 1] = "SideSheetV2";
    ModalType[ModalType["LateralModal"] = 2] = "LateralModal";
    ModalType[ModalType["PopInModal"] = 3] = "PopInModal";
    ModalType[ModalType["MaxiModal"] = 4] = "MaxiModal";
    ModalType[ModalType["BottomModal"] = 5] = "BottomModal";
})(ModalType || (ModalType = {}));
class ModalService {
    constructor(overlay, injector) {
        this.overlay = overlay;
        this.injector = injector;
        this.isScrollingSubject = new BehaviorSubject(false);
        this.isOverflownSubject = new BehaviorSubject(false);
        this.isBottomContentSubject = new BehaviorSubject(false);
        this.isScrollingState$ = this.isScrollingSubject.asObservable();
        this.isOverflownState$ = this.isOverflownSubject.asObservable();
        this.isBottomContentState$ = this.isBottomContentSubject.asObservable();
    }
    isScrolling(v) {
        this.isScrollingSubject.next(v);
    }
    isBottomContent(v) {
        this.isBottomContentSubject.next(v);
    }
    isOverflown(v) {
        this.isOverflownSubject.next(v);
    }
    show(params) {
        const backDropClose = params.backDropClose || params.backDropClose === undefined;
        const wantsToCloseSubject = new Subject();
        const modalInput = {
            close: (result) => {
                wantsToCloseSubject.next(result);
                wantsToCloseSubject.complete();
            },
            input: params.input
        };
        const contentInjector = Injector.create({
            providers: [{ provide: ONEP_MODAL_INPUT, useValue: modalInput }],
            parent: this.injector
        });
        const modalData = {
            close: new Subject(),
            content: new ComponentPortal(params.component, undefined, contentInjector),
            wantsToCloseSubject,
            input: params.input,
            class: params.class,
            closeText: params.closeText,
            fullHeight: params.fullHeight
        };
        const portalInjector = Injector.create({
            providers: [{ provide: ONEP_MODAL_DATA, useValue: modalData }],
            parent: contentInjector
        });
        let simpleModalPortal;
        let positionStrategy;
        switch (params.type) {
            case ModalType.BottomModal:
                simpleModalPortal = new ComponentPortal(ControlBottomModalComponent, undefined, portalInjector);
                positionStrategy = this.overlay.position().global().bottom('0px');
                break;
            case ModalType.SideSheetV2:
                simpleModalPortal = new ComponentPortal(ControlSideSheetV2Component, undefined, portalInjector);
                positionStrategy = this.overlay.position().global().right('0px');
                break;
            case ModalType.SideSheet:
            case ModalType.LateralModal:
                simpleModalPortal = new ComponentPortal(ControlSideSheetComponent, undefined, portalInjector);
                positionStrategy = this.overlay.position().global().right('0px');
                break;
            case ModalType.MaxiModal:
                simpleModalPortal = new ComponentPortal(ControlMaxiModalComponent, undefined, portalInjector);
                positionStrategy = this.overlay
                    .position()
                    .global()
                    .centerHorizontally()
                    .centerVertically();
                break;
            case ModalType.PopInModal:
            default:
                simpleModalPortal = new ComponentPortal(ControlPopInModalComponent, undefined, portalInjector);
                positionStrategy = this.overlay
                    .position()
                    .global()
                    .centerHorizontally()
                    .centerVertically();
                break;
        }
        const openedModalOverlayRef = this.overlay.create({
            positionStrategy,
            scrollStrategy: this.overlay.scrollStrategies.block(),
            backdropClass: 'onep-modal-backdrop',
            hasBackdrop: params.type !== ModalType.MaxiModal
        });
        modalData.close.subscribe(() => {
            openedModalOverlayRef.detach();
            openedModalOverlayRef.dispose();
        });
        openedModalOverlayRef.backdropClick().subscribe(() => {
            if (backDropClose) {
                wantsToCloseSubject.next(undefined);
                wantsToCloseSubject.complete();
            }
        });
        openedModalOverlayRef.attach(simpleModalPortal);
        return {
            closed$: modalData.close.asObservable(),
            close: (result) => {
                wantsToCloseSubject.next(result);
                wantsToCloseSubject.complete();
            }
        };
    }
}
ModalService.ɵfac = function ModalService_Factory(t) { return new (t || ModalService)(ɵngcc0.ɵɵinject(ɵngcc5.OverlayService), ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
ModalService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ModalService, factory: ModalService.ɵfac });
ModalService.ctorParameters = () => [
    { type: OverlayService },
    { type: Injector }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModalService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc5.OverlayService }, { type: ɵngcc0.Injector }]; }, null); })();

class PopInModalButtonsComponent {
    constructor() { }
    ngOnInit() { }
}
PopInModalButtonsComponent.ɵfac = function PopInModalButtonsComponent_Factory(t) { return new (t || PopInModalButtonsComponent)(); };
PopInModalButtonsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PopInModalButtonsComponent, selectors: [["onep-pop-in-modal-buttons"]], ngContentSelectors: _c1, decls: 1, vars: 0, template: function PopInModalButtonsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } } });
PopInModalButtonsComponent.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PopInModalButtonsComponent, [{
        type: Component,
        args: [{ selector: 'onep-pop-in-modal-buttons', template: "<ng-content></ng-content>\n" }]
    }], function () { return []; }, null); })();

class PopInModalContentComponent {
    constructor() { }
    ngOnInit() { }
}
PopInModalContentComponent.ɵfac = function PopInModalContentComponent_Factory(t) { return new (t || PopInModalContentComponent)(); };
PopInModalContentComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PopInModalContentComponent, selectors: [["onep-pop-in-modal-content"]], ngContentSelectors: _c1, decls: 2, vars: 0, consts: [[1, "body-1"]], template: function PopInModalContentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } } });
PopInModalContentComponent.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PopInModalContentComponent, [{
        type: Component,
        args: [{ selector: 'onep-pop-in-modal-content', template: "<div class=\"body-1\">\n  <ng-content></ng-content>\n</div>\n" }]
    }], function () { return []; }, null); })();

class PopInModalTitleComponent {
    constructor() { }
    ngOnInit() { }
}
PopInModalTitleComponent.ɵfac = function PopInModalTitleComponent_Factory(t) { return new (t || PopInModalTitleComponent)(); };
PopInModalTitleComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PopInModalTitleComponent, selectors: [["onep-pop-in-modal-title"]], ngContentSelectors: _c1, decls: 2, vars: 0, template: function PopInModalTitleComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "h4");
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } } });
PopInModalTitleComponent.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PopInModalTitleComponent, [{
        type: Component,
        args: [{ selector: 'onep-pop-in-modal-title', template: "<h4><ng-content></ng-content></h4>\n" }]
    }], function () { return []; }, null); })();

/**
 * Component that wraps the pop in modal pattern
 */
class PopInModalComponent {
    constructor() {
        /**
         * Emits something when the modal is closed
         */
        this.closeModal = new EventEmitter();
    }
    ngOnInit() { }
}
PopInModalComponent.ɵfac = function PopInModalComponent_Factory(t) { return new (t || PopInModalComponent)(); };
PopInModalComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PopInModalComponent, selectors: [["onep-pop-in-modal"]], inputs: { content: "content" }, outputs: { closeModal: "closeModal" }, decls: 3, vars: 1, consts: [[1, "onep-pop-in-modal-container"], [3, "cdkPortalOutlet"], ["onepIcon", "close_error", 1, "onep-pop-in-modal-close", 3, "click"]], template: function PopInModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, PopInModalComponent_ng_template_1_Template, 0, 0, "ng-template", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(2, "svg", 2);
        ɵngcc0.ɵɵlistener("click", function PopInModalComponent_Template__svg_svg_click_2_listener() { return ctx.closeModal.emit(); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("cdkPortalOutlet", ctx.content);
    } }, dependencies: [ɵngcc3.IconComponent, ɵngcc1.CdkPortalOutlet], encapsulation: 2 });
PopInModalComponent.ctorParameters = () => [];
PopInModalComponent.propDecorators = {
    content: [{ type: Input }],
    closeModal: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PopInModalComponent, [{
        type: Component,
        args: [{
                selector: 'onep-pop-in-modal',
                template: "<div class=\"onep-pop-in-modal-container\">\n  <ng-template [cdkPortalOutlet]=\"content\"></ng-template>\n</div>\n<svg class=\"onep-pop-in-modal-close\" (click)=\"closeModal.emit()\" onepIcon=\"close_error\"></svg>\n"
            }]
    }], function () { return []; }, { closeModal: [{
            type: Output
        }], content: [{
            type: Input
        }] }); })();

/**
 * Component that wraps the lateral modal pattern
 */
class SideSheetComponent {
    constructor(modalService) {
        this.modalService = modalService;
        this.isScrolling = false;
        this.displayHeaderLine = this.isScrolling;
        /**
         * Emits when the modal is closed
         */
        this.closeModal = new EventEmitter();
    }
    ngOnInit() {
        this.modalService.isScrollingState$.subscribe((v) => {
            this.isScrolling = v;
        });
    }
}
SideSheetComponent.ɵfac = function SideSheetComponent_Factory(t) { return new (t || SideSheetComponent)(ɵngcc0.ɵɵdirectiveInject(ModalService)); };
SideSheetComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SideSheetComponent, selectors: [["onep-side-sheet"]], hostVars: 2, hostBindings: function SideSheetComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("onep-side-sheet-scrolling", ctx.isScrolling);
    } }, inputs: { content: "content" }, outputs: { closeModal: "closeModal" }, decls: 4, vars: 2, consts: [[1, "onep-header-modal-sidesheet", 3, "displayHeaderLine"], [1, "onep-side-sheet-container"], [3, "cdkPortalOutlet"], ["onepIcon", "close_error", 1, "onep-side-sheet-close", 3, "click"]], template: function SideSheetComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "onep-header-modal", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, SideSheetComponent_ng_template_2_Template, 0, 0, "ng-template", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(3, "svg", 3);
        ɵngcc0.ɵɵlistener("click", function SideSheetComponent_Template__svg_svg_click_3_listener() { return ctx.closeModal.emit(); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("displayHeaderLine", ctx.displayHeaderLine);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("cdkPortalOutlet", ctx.content);
    } }, dependencies: [ɵngcc3.IconComponent, ɵngcc1.CdkPortalOutlet, ɵngcc6.HeaderComponent], encapsulation: 2 });
SideSheetComponent.ctorParameters = () => [
    { type: ModalService }
];
SideSheetComponent.propDecorators = {
    content: [{ type: Input }],
    isScrolling: [{ type: HostBinding, args: ['class.onep-side-sheet-scrolling',] }],
    closeModal: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SideSheetComponent, [{
        type: Component,
        args: [{
                selector: 'onep-side-sheet',
                template: "<onep-header-modal class=\"onep-header-modal-sidesheet\" [displayHeaderLine]=\"displayHeaderLine\">\n</onep-header-modal>\n<div class=\"onep-side-sheet-container\">\n  <ng-template [cdkPortalOutlet]=\"content\"></ng-template>\n</div>\n<svg class=\"onep-side-sheet-close\" (click)=\"closeModal.emit()\" onepIcon=\"close_error\"></svg>\n"
            }]
    }], function () { return [{ type: ModalService }]; }, { isScrolling: [{
            type: HostBinding,
            args: ['class.onep-side-sheet-scrolling']
        }], closeModal: [{
            type: Output
        }], content: [{
            type: Input
        }] }); })();

class MaxiModalContainerComponent {
    constructor() { }
}
MaxiModalContainerComponent.ɵfac = function MaxiModalContainerComponent_Factory(t) { return new (t || MaxiModalContainerComponent)(); };
MaxiModalContainerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MaxiModalContainerComponent, selectors: [["onep-maxi-modal-container"]], ngContentSelectors: _c1, decls: 1, vars: 0, template: function MaxiModalContainerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } } });
MaxiModalContainerComponent.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MaxiModalContainerComponent, [{
        type: Component,
        args: [{ selector: 'onep-maxi-modal-container', template: "<ng-content></ng-content>\n" }]
    }], function () { return []; }, null); })();

class SideSheetBottomComponent {
    constructor(modalService) {
        this.modalService = modalService;
        this.subscriptions = [];
        this.overflowClass = false;
        this.endContentClass = false;
    }
    ngAfterContentInit() {
        this.subscriptions.push(this.modalService.isOverflownState$.subscribe((isOverflown) => {
            this.overflowClass = isOverflown;
        }), this.modalService.isBottomContentState$.subscribe((isBottomContent) => {
            this.endContentClass = isBottomContent;
        }));
    }
    ngOnDestroy() {
        this.subscriptions.forEach((s) => s.unsubscribe());
    }
}
SideSheetBottomComponent.ɵfac = function SideSheetBottomComponent_Factory(t) { return new (t || SideSheetBottomComponent)(ɵngcc0.ɵɵdirectiveInject(ModalService)); };
SideSheetBottomComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SideSheetBottomComponent, selectors: [["onep-side-sheet-bottom"], ["onep-side-sheet-v2-bottom"]], hostVars: 4, hostBindings: function SideSheetBottomComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("onep-side-sheet-bottom-overflow", ctx.overflowClass)("onep-side-sheet-bottom-end-content", ctx.endContentClass);
    } }, ngContentSelectors: _c1, decls: 1, vars: 0, template: function SideSheetBottomComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } } });
SideSheetBottomComponent.ctorParameters = () => [
    { type: ModalService }
];
SideSheetBottomComponent.propDecorators = {
    overflowClass: [{ type: HostBinding, args: ['class.onep-side-sheet-bottom-overflow',] }],
    endContentClass: [{ type: HostBinding, args: ['class.onep-side-sheet-bottom-end-content',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SideSheetBottomComponent, [{
        type: Component,
        args: [{ selector: 'onep-side-sheet-bottom, onep-side-sheet-v2-bottom', template: "<ng-content></ng-content>\n" }]
    }], function () { return [{ type: ModalService }]; }, { overflowClass: [{
            type: HostBinding,
            args: ['class.onep-side-sheet-bottom-overflow']
        }], endContentClass: [{
            type: HostBinding,
            args: ['class.onep-side-sheet-bottom-end-content']
        }] }); })();

class SideSheetScrollableContainerComponent {
    constructor(responsiveService, modalService, el) {
        this.responsiveService = responsiveService;
        this.modalService = modalService;
        this.el = el;
        this.subscriptions = [];
        this.isMobile = false;
        this.headerShadowOffset = 40;
    }
    onScroll($event) {
        this.modalService.isScrolling($event.target.scrollTop > (this.isMobile ? 0 : this.headerShadowOffset));
        this.modalService.isBottomContent($event.target.offsetHeight + $event.target.scrollTop >=
            $event.target.scrollHeight);
    }
    isOverflown() {
        return (this.el.nativeElement.scrollHeight > this.el.nativeElement.clientHeight ||
            this.el.nativeElement.scrollWidth > this.el.nativeElement.clientWidth);
    }
    ngOnInit() {
        this.subscriptions.push(this.responsiveService.isMobile$.subscribe((isMobile) => {
            this.isMobile = isMobile;
        }));
    }
    ngDoCheck() {
        this.modalService.isOverflown(this.isOverflown());
    }
    ngOnDestroy() {
        this.subscriptions.forEach((s) => s.unsubscribe());
    }
}
SideSheetScrollableContainerComponent.ɵfac = function SideSheetScrollableContainerComponent_Factory(t) { return new (t || SideSheetScrollableContainerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.ResponsiveService), ɵngcc0.ɵɵdirectiveInject(ModalService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
SideSheetScrollableContainerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SideSheetScrollableContainerComponent, selectors: [["onep-side-sheet-v2-scrollable-container"], ["onep-side-sheet-scrollable-container"], ["onep-side-sheet-scrollable-content"]], hostBindings: function SideSheetScrollableContainerComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("scroll", function SideSheetScrollableContainerComponent_scroll_HostBindingHandler($event) { return ctx.onScroll($event); });
    } }, inputs: { headerShadowOffset: "headerShadowOffset" }, ngContentSelectors: _c1, decls: 2, vars: 0, consts: [[1, "onep-side-content"]], template: function SideSheetScrollableContainerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } } });
SideSheetScrollableContainerComponent.ctorParameters = () => [
    { type: ResponsiveService },
    { type: ModalService },
    { type: ElementRef }
];
SideSheetScrollableContainerComponent.propDecorators = {
    headerShadowOffset: [{ type: Input }],
    onScroll: [{ type: HostListener, args: ['scroll', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SideSheetScrollableContainerComponent, [{
        type: Component,
        args: [{ selector: 'onep-side-sheet-v2-scrollable-container, onep-side-sheet-scrollable-container, onep-side-sheet-scrollable-content', template: "<div class=\"onep-side-content\">\n  <ng-content></ng-content>\n</div>\n" }]
    }], function () { return [{ type: ɵngcc4.ResponsiveService }, { type: ModalService }, { type: ɵngcc0.ElementRef }]; }, { headerShadowOffset: [{
            type: Input
        }], onScroll: [{
            type: HostListener,
            args: ['scroll', ['$event']]
        }] }); })();

class SideSheetV2Component {
    constructor(modalService) {
        this.modalService = modalService;
        this.fullHeight = false;
        this.isScrolling = false;
        this.displayHeaderLine = this.isScrolling;
        /**
         * Emits when the modal is closed
         */
        this.closeModal = new EventEmitter();
    }
    ngOnInit() {
        this.modalService.isScrollingState$.subscribe((v) => {
            this.isScrolling = v;
        });
    }
}
SideSheetV2Component.ɵfac = function SideSheetV2Component_Factory(t) { return new (t || SideSheetV2Component)(ɵngcc0.ɵɵdirectiveInject(ModalService)); };
SideSheetV2Component.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SideSheetV2Component, selectors: [["onep-side-sheet-v2"]], hostVars: 2, hostBindings: function SideSheetV2Component_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("onep-side-sheet-scrolling", ctx.isScrolling);
    } }, inputs: { fullHeight: "fullHeight", content: "content" }, outputs: { closeModal: "closeModal" }, decls: 7, vars: 3, consts: [[1, "onep-header-modal-sidesheet", 3, "displayHeaderLine"], ["onepIcon", "close_error", 1, "onep-header-close", 3, "click"], ["class", "onep-side-sheet-outlet", 4, "ngIf"], [4, "ngIf"], [1, "onep-side-sheet-outlet"], [3, "cdkPortalOutlet"]], template: function SideSheetV2Component_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "onep-header-modal", 0);
        ɵngcc0.ɵɵelement(1, "onep-header-left")(2, "onep-header-center");
        ɵngcc0.ɵɵelementStart(3, "onep-header-right");
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(4, "svg", 1);
        ɵngcc0.ɵɵlistener("click", function SideSheetV2Component_Template__svg_svg_click_4_listener() { return ctx.closeModal.emit(); });
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵtemplate(5, SideSheetV2Component_div_5_Template, 2, 1, "div", 2);
        ɵngcc0.ɵɵtemplate(6, SideSheetV2Component_6_Template, 1, 1, null, 3);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("displayHeaderLine", ctx.displayHeaderLine);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", ctx.fullHeight);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.fullHeight);
    } }, dependencies: [ɵngcc2.NgIf, ɵngcc3.IconComponent, ɵngcc1.CdkPortalOutlet, ɵngcc6.HeaderComponent, ɵngcc6.HeaderLeftComponent, ɵngcc6.HeaderCenterComponent, ɵngcc6.HeaderRightComponent] });
SideSheetV2Component.ctorParameters = () => [
    { type: ModalService }
];
SideSheetV2Component.propDecorators = {
    content: [{ type: Input }],
    fullHeight: [{ type: Input }],
    isScrolling: [{ type: HostBinding, args: ['class.onep-side-sheet-scrolling',] }],
    closeModal: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SideSheetV2Component, [{
        type: Component,
        args: [{ selector: 'onep-side-sheet-v2', template: "<onep-header-modal class='onep-header-modal-sidesheet' [displayHeaderLine]='displayHeaderLine'>\n  <onep-header-left></onep-header-left>\n  <onep-header-center></onep-header-center>\n  <onep-header-right>\n    <svg class='onep-header-close' (click)='closeModal.emit()' onepIcon='close_error'></svg>\n  </onep-header-right>\n</onep-header-modal>\n<div class='onep-side-sheet-outlet' *ngIf='fullHeight'>\n  <ng-template [cdkPortalOutlet]='content'></ng-template>\n</div>\n\n<ng-template *ngIf='!fullHeight' [cdkPortalOutlet]='content'></ng-template>\n" }]
    }], function () { return [{ type: ModalService }]; }, { fullHeight: [{
            type: Input
        }], isScrolling: [{
            type: HostBinding,
            args: ['class.onep-side-sheet-scrolling']
        }], closeModal: [{
            type: Output
        }], content: [{
            type: Input
        }] }); })();

/**
 * Module containing all the components related to the modal.
 * See README for example usages.
 */
class ModalModule {
    static forRoot() {
        return {
            ngModule: ModalModule,
            providers: [ModalService]
        };
    }
}
ModalModule.ɵfac = function ModalModule_Factory(t) { return new (t || ModalModule)(); };
ModalModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ModalModule });
ModalModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        GridModule.forRoot(),
        IconModule,
        OverlayModule.forRoot(),
        PortalModule,
        HeaderModule,
        HeaderModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModalModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    SideSheetComponent,
                    ControlSideSheetComponent,
                    PopInModalComponent,
                    ControlPopInModalComponent,
                    PopInModalTitleComponent,
                    PopInModalContentComponent,
                    PopInModalButtonsComponent,
                    MaxiModalComponent,
                    ControlMaxiModalComponent,
                    BottomModalComponent,
                    ControlBottomModalComponent,
                    HeaderMaxiModalComponent,
                    MaxiModalContainerComponent,
                    SideSheetBottomComponent,
                    SideSheetScrollableContainerComponent,
                    SideSheetV2Component,
                    ControlSideSheetV2Component
                ],
                imports: [
                    CommonModule,
                    GridModule.forRoot(),
                    IconModule,
                    OverlayModule.forRoot(),
                    PortalModule,
                    HeaderModule,
                    HeaderModule
                ],
                exports: [
                    SideSheetComponent,
                    PopInModalComponent,
                    PopInModalTitleComponent,
                    PopInModalContentComponent,
                    PopInModalButtonsComponent,
                    MaxiModalComponent,
                    BottomModalComponent,
                    HeaderMaxiModalComponent,
                    MaxiModalContainerComponent,
                    SideSheetBottomComponent,
                    SideSheetScrollableContainerComponent,
                    SideSheetV2Component
                ],
                entryComponents: [
                    ControlSideSheetComponent,
                    ControlPopInModalComponent,
                    ControlMaxiModalComponent,
                    ControlBottomModalComponent,
                    ControlSideSheetV2Component
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ModalModule, { declarations: function () { return [SideSheetComponent, ControlSideSheetComponent, PopInModalComponent, ControlPopInModalComponent, PopInModalTitleComponent, PopInModalContentComponent, PopInModalButtonsComponent, MaxiModalComponent, ControlMaxiModalComponent, BottomModalComponent, ControlBottomModalComponent, HeaderMaxiModalComponent, MaxiModalContainerComponent, SideSheetBottomComponent, SideSheetScrollableContainerComponent, SideSheetV2Component, ControlSideSheetV2Component]; }, imports: function () { return [CommonModule, ɵngcc4.GridModule, IconModule, ɵngcc5.OverlayModule, PortalModule,
        HeaderModule,
        HeaderModule]; }, exports: function () { return [SideSheetComponent, PopInModalComponent, PopInModalTitleComponent, PopInModalContentComponent, PopInModalButtonsComponent, MaxiModalComponent, BottomModalComponent, HeaderMaxiModalComponent, MaxiModalContainerComponent, SideSheetBottomComponent, SideSheetScrollableContainerComponent, SideSheetV2Component]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { BottomModalComponent, ControlBottomModalComponent, ControlMaxiModalComponent, ControlPopInModalComponent, ControlSideSheetComponent, HeaderMaxiModalComponent, MaxiModalComponent, MaxiModalContainerComponent, ModalModule, ModalService, ModalType, ONEP_MODAL_DATA, ONEP_MODAL_INPUT, PopInModalButtonsComponent, PopInModalComponent, PopInModalContentComponent, PopInModalTitleComponent, SideSheetBottomComponent, SideSheetComponent, SideSheetScrollableContainerComponent, SideSheetV2Component, ControlSideSheetV2Component as ɵa };

